import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import STATES from 'assets/data/us-states';
import UKRAINE_REGIONS from 'assets/data/ukraine-regions';
import RestrictionWarning from 'components/RestrictionWarning';
import { Label } from 'components/Typography';
import Tooltip from 'components/Tooltip';
import CountrySelect from '../CountrySelect';
import TextInput from '../TextInput';
import Select from '../Select';
import { Card, Line1, Row } from './styled';

const usStatesDropdown = STATES.map((state) => ({
  value: state.name,
  label: state.name
}));

const ukraineRegionsDropdown = UKRAINE_REGIONS.map((state) => ({
  value: state.name,
  label: state.name
}));

const AddressInput = ({
  formik,
  className,
  showStateRestrictionWarning,
  tooltip = '',
  variant = 'dark',
  size = 'medium',
  spacing = 'small',
  label = '',
  disabled = false
}) => {
  useEffect(() => {
    if (
      (formik.values.address.country === 'US' ||
        formik.values.address.country === 'UA') &&
      formik.values.address.state?.length <= 0
    ) {
      formik.setFieldValue('address.state', '');
    }
  }, [formik.values.address.country]); // eslint-disable-line
  return (
    <>
      <Label variant={variant} size={size} spacing={spacing}>
        {label} {tooltip && <Tooltip>{tooltip}</Tooltip>}
      </Label>
      <Card className={className} variant={variant}>
        <CountrySelect
          label="Country"
          name="address.country"
          formik={formik}
          disabled={disabled}
        />
        <Line1 label="Address" name="address.line1" formik={formik} disabled={disabled} />
        <TextInput
          name="address.line2"
          placeholder="Flat, apartment, etc. (optional)"
          formik={formik}
          disabled={disabled}
        />
        {formik.values.address.country !== 'US' &&
          formik.values.address.country !== 'UA' && (
            <TextInput
              label="State"
              optional
              name="address.state"
              formik={formik}
              disabled={disabled}
            />
          )}
        {formik.values.address.country === 'US' && (
          <>
            <Select
              label="State"
              formik={formik}
              name="address.state"
              options={usStatesDropdown}
              disabled={disabled}
            />
            {showStateRestrictionWarning && <RestrictionWarning field="state" />}
          </>
        )}
        {formik.values.address.country === 'UA' && (
          <>
            <Select
              label="Region"
              formik={formik}
              name="address.state"
              options={ukraineRegionsDropdown}
              disabled={disabled}
            />
            {showStateRestrictionWarning && <RestrictionWarning field="state" />}
          </>
        )}
        <Row>
          <TextInput
            label="City"
            name="address.city"
            formik={formik}
            disabled={disabled}
          />
          <TextInput
            label="Postcode"
            name="address.zipCode"
            formik={formik}
            disabled={disabled}
          />
        </Row>
      </Card>
    </>
  );
};

AddressInput.propTypes = {
  formik: PropTypes.object,
  variant: PropTypes.oneOf(['light', 'dark', 'blue', 'turquoise']),
  showStateRestrictionWarning: PropTypes.bool,
  className: PropTypes.string,
  label: PropTypes.string,
  tooltip: PropTypes.string,
  size: PropTypes.oneOf(['medium', 'large']),
  spacing: PropTypes.string,
  disabled: PropTypes.bool
};

export default AddressInput;
